import { render, staticRenderFns } from "./LogoImage.vue?vue&type=template&id=648ab357&"
import script from "./LogoImage.vue?vue&type=script&lang=ts&"
export * from "./LogoImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports